import React from 'react';
import styled from 'styled-components';
import useContentPoliticas from '../hooks/parameter/useContentPoliticas.js';

const DivContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  min-height: 400px;
  max-width: 1200px;

  p {
    text-align: center;

    img {
      margin-top: 2.5rem;
      width: 100% !important;
    }
  }
`;

export const PagePoliticaInstitucional = () => {
  window.scroll(0, 0);
  const { contentPoliticas } = useContentPoliticas();

  const bodyHTML =
    contentPoliticas.length > 0 && contentPoliticas[1].texto_contenido;

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <DivContainer id='contBodyHTML'>
          <p dangerouslySetInnerHTML={{ __html: bodyHTML }} />
        </DivContainer>
      </div>
    </>
  );
};
